export default {
  segments: null,
  segment: null,
  surveyOptions: null,
  distributionOptions: null,
  metadataOptions: null,
  categoryOptions: null
};

export function getSegmentDefault() {
  return {
    uuid: null,
    name: "Untitled",
    rules: {
      static: {
        filtered: false,
        surveys: [],
        distributions: [],
        sending_channel: [],
        answer_channel: [],
        categories: [],
        health_score: null,
        financial_status: null,
        answer_status: null,
        send_status: null,
        identification: null,
        sending_date: {
          starts_at: null,
          ends_at: null
        },
        answer_date: {
          starts_at: null,
          ends_at: null
        }
      },
      metadata: "[[]]"
    }
  };
}
